interface UserWithPermissions {
    role?: string;
    permissions?: string[];
}

export function hasPermission(user: UserWithPermissions | null | undefined, permission: string): boolean {
    if (!user) return false;
    if (user.role === 'super_admin') return true;
    return user.permissions?.includes(permission) ?? false;
}

export function hasAnyPermission(user: UserWithPermissions | null | undefined, permissions: string[]): boolean {
    if (!user) return false;
    if (user.role === 'super_admin') return true;
    return permissions.some((p) => user.permissions?.includes(p));
}

/**
 * Debug tooling (raw WebRTC transport stats) is held to the ROLE, not just the
 * `cameras.debug` permission — a custom role could be granted that permission
 * without being meant to see transport internals. Allowed for super admins and
 * admins; the seeded "Cloud Admin" account is an `admin`, there is no separate
 * cloud-admin role in the catalog (see backend constants ROLES).
 */
const DEBUG_ROLES = ['super_admin', 'admin'];

export function canUseDebugTools(user: UserWithPermissions | null | undefined): boolean {
    if (!user?.role) return false;
    return DEBUG_ROLES.includes(user.role) && hasPermission(user, 'cameras.debug');
}